import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import type { IconType } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface FeatureCardProps {
  color: "purple" | "green" | "pink" | "blue" | "lavender";
  icon: IconType;
  feature: "feature_1" | "feature_2" | "feature_3" | "feature_4" | "feature_5";
  iconSize?: number;
  featureCount?: number;
}

const bgColormap = {
  purple: "bg-[#EEEEFF]",
  green: "bg-[#EBFAF5]",
  pink: "bg-[#FFF1F3]",
  blue: "bg-[#E7F4FF]",
  lavender: "bg-[#EDE4FF]",
};

const darkIconBGColorMap = {
  purple: "bg-[#DAD9FB]",
  green: "bg-[#B0EBD9]",
  pink: "bg-[#FFC9D3]",
  blue: "bg-[#C9E7FF]",
  lavender: "bg-[#DAC8FF]",
};

export const FeatureCard = ({
  color,
  feature,
  icon,
  iconSize = 20,
}: FeatureCardProps) => {
  const translationRoot = `courses.landing_page_v3.${feature}`;
  return (
    <div
      className={classNames(
        "col-span-6 h-[500px] rounded-[10px] p-12 lg:col-span-5 lg:pb-4",
        bgColormap[color],
      )}
    >
      <div
        className={classNames(
          "flex h-12 w-12 items-center justify-center rounded-full",
          darkIconBGColorMap[color],
        )}
      >
        <Icon type={icon} size={iconSize} />
      </div>
      <div className="mt-5">
        <Typography.TitleLg color="text-[#2B2E33]">
          {t(`${translationRoot}.title`)}
        </Typography.TitleLg>
      </div>
      <div className="mt-5">
        <Typography.BodyMd color="text-[#2B2E33]">
          {t(`${translationRoot}.description`)}
        </Typography.BodyMd>
      </div>
    </div>
  );
};
